import { Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { ConnectButton } from "@dzambalaorg/provider-wagmi";
import { Theme } from "@dzambalaorg/provider-theme";
import { Localization } from "@dzambalaorg/provider-localization";
import { EnabledLanguages } from "@dzambalaorg/constants";
import { AppShellLayout } from "@dzambalaorg/ui-kit";

import { Sections } from "./sections";
import { StyledGrow, StyledLink, StyledToolbar } from "./styled";
import { Logo } from "../../../shared";

export const Header = () => {
  return (
    <AppShellLayout.Header>
      <StyledToolbar>
        <StyledLink component={RouterLink} to="/">
          <Logo width={40} height={40} />
          <Box>Cascadify - Marketplace</Box>
        </StyledLink>
        <StyledGrow />
        <Theme />
        <Localization languages={Object.values(EnabledLanguages)} />
        <ConnectButton />
        <Sections />
      </StyledToolbar>
    </AppShellLayout.Header>
  );
};
